import { useEffect, useRef, useState } from "react";
import { CopyButton } from "./CopyButton.tsx";
import { GooglyEyes } from "./GooglyEyes.tsx";
import { Icon } from "./Icon.tsx";
import styles from "./NotOwner.module.css";
import ui from "./ui.module.css";

export class NotOwnerError extends Error {
  readonly email: string;

  constructor(email: string) {
    super(`${email} does not own this drive.`);
    this.name = "NotOwnerError";
    this.email = email;
  }
}

export function NotOwner({ email }: { email: string }) {
  const heading = useRef<HTMLHeadingElement>(null);
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    document.title = "This drive is private · Vault";
    heading.current?.focus();
    setAnnouncement(`This drive is private. Signed in as ${email}.`);
  }, [email]);

  return (
    <main className={styles.page}>
      <div className={`${ui.card} ${styles.content}`}>
        <GooglyEyes size="lg" className={styles.mark} />
        <h1 className={styles.title} ref={heading} tabIndex={-1}>
          This drive is private
        </h1>
        <p className={styles.account}>
          Signed in as <strong className={styles.email}>{email}</strong>
        </p>
        <div className={styles.actions}>
          <a href="/auth/logout" className={ui.button} data-variant="primary">
            <Icon name="signOut" />
            Use a different account
          </a>
          <CopyButton value={email} label="Copy my address" />
        </div>
        <p className={ui.visuallyHidden} role="status" aria-live="polite">
          {announcement}
        </p>
      </div>
    </main>
  );
}
